<template>
<div>
  <h5>Some of my / participating projects</h5>
  <ul>
    <li v-for="project in projects" class="clearfix">
      <div class="con">
          <h3><i aria-hidden="true" data-icon="["></i>{{project.name}}<em>{{project.type}}</em></h3>
          <p>{{project.description}}</p>
      </div>
    </li>
  </ul>
</div>
</template>

<<script>
export default {
  name: 'projects',
  props: {
    projects: Array
  }
}
</script>
<<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Projects.vue